import qs from 'qs';
import { useLocation } from 'react-router-dom';

export function useQuery<Params extends { [K in keyof Params]?: string | string[] }>(): Params {
  const queryString = useLocation().search.replace('?', '');

  return qs.parse(queryString) as Params;
}
